import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/scenarios";
const scenariosQuery = { orderBy: "id desc" };

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...scenariosQuery });
    return request(`${resource}/getlist${query}`, { method: "GET" }, { countInHeaders: true });
};

const list = (params: {}) => request(`${resource}/getlist${containsQuery(params)}`, { method: "GET" });

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));

const getItem = (id: number) => {
    return request(`${resource}/getWholeScenario/${id}`, { method: "GET" }).then((data) => {
        if (data) {
            const { questions, hasDriverAnswers, ...scenario } = data;
            return { scenario, questions, hasDriverAnswers };
        } else {
            return data;
        }
    });
};
const getBidScenarios = (id: number) => request(`${resource}/getBidScenarios/${id}`, { method: "GET" });

const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

const copy = (params: {}) => alertRequest(`${resource}/copy`, body(params));

const deleteScenarioQuestion = (params: {}) => alertRequest(`${resource}/deleteScenarioQuestion`, body(params));

const deleteScenarioAnswerOption = (params: {}) => alertRequest(`${resource}/deleteScenarioAnswerOption`, body(params));

const applyScenarioQuestion = (params: {}) => alertRequest(`${resource}/applyScenarioQuestion`, body(params));

const applyScenarioAnswerOption = (params: {}) => request(`${resource}/applyScenarioAnswerOption`, body(params));

const applyScenarioLogistAnswers = (params: {}) => request(`${resource}/applyScenarioLogistAnswers`, body(params));

const uploadFile = (params: {}) => request(`${resource}/uploadFile`, params);

const deleteFile = (params: {}) => request(`${resource}/deleteFile`, body(params));

export {
    index,
    apply,
    getItem,
    delItem,
    copy,
    list,
    applyScenarioQuestion,
    deleteScenarioQuestion,
    applyScenarioAnswerOption,
    deleteScenarioAnswerOption,
    getBidScenarios,
    applyScenarioLogistAnswers,
    uploadFile,
    deleteFile,
};
